/**
 * @generated SignedSource<<b42acb21d89838bb1bc55fff2f0d4fdc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type shortcutNavigationTab_businessTabs_OldShortcutNavigationTab$data = {
  readonly __typename: string;
  readonly __id: string;
  readonly canRemove: boolean | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabOld_Tab">;
  readonly " $fragmentType": "shortcutNavigationTab_businessTabs_OldShortcutNavigationTab";
};
export type shortcutNavigationTab_businessTabs_OldShortcutNavigationTab$key = {
  readonly " $data"?: shortcutNavigationTab_businessTabs_OldShortcutNavigationTab$data;
  readonly " $fragmentSpreads": FragmentRefs<"shortcutNavigationTab_businessTabs_OldShortcutNavigationTab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "shortcutNavigationTab_businessTabs_OldShortcutNavigationTab",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_navigationKitTabOld_Tab"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "canRemove"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "976a6a04f46be97f5b60fab212990714";

export default node;
